<div class="main-container">
  <div class="mdl-container">
        <div class="d-grid mdl-header">
            <div class="center-svg"><img src="assets/svg/charts-icon.svg" alt=""></div>
            <div>
                <h4 class="text-semibold">Gráficos</h4>
            </div>
            <div>
                <h3 class="color-gray text-semibold">
                <div class="center-svg">
                    <img (click)="closeMdl()" class="close-button" src="assets/svg/close-icon.svg" alt="">
                </div>
                </h3>
            </div>
        </div>
        <div class="mdl-body">
            <div class="mt-5"><b class="color-org">*</b> Seleccionar el gráfico</div>
            <div>
                <select class="crm-input" id="" style="padding: 10px !important;" (change)="changeGraphData()" [(ngModel)]="graphValue">
                    @for(item of slcOptions; track item.value){
                        <option [value]="item.value">{{item.opt}}</option>
                    }
                </select>
            </div>
            <div class="d-flex flex-column justify-center mt-5">
                <div class="d-grid grid-chart">
                    <div *ngIf="selectedChart === 'doughnut'">
                        <canvas *ngIf="isBrowser" baseChart
                                [labels]="doughnutChartLabels"
                                [datasets]="doughnutChartDatasets"
                                [options]="doughnutChartOptions"
                                [legend]="false"
                                [type]="'doughnut'">
                        </canvas>
                    </div>
                    
                    <div *ngIf="selectedChart === 'bar'">
                        <canvas *ngIf="isBrowser" baseChart
                                [data]="{ labels: barChartLabels, datasets: barChartDatasets }"
                                [options]="barChartOptions"
                                [legend]="false"
                                [type]="'bar'">
                        </canvas>
                    </div>

                    <div style="margin-top: auto;">
                        <div class="center-svg" (click)="showGraphSelection(); $event.stopPropagation();"><img src="assets/svg/gear-icon.svg" alt=""></div> 
                        <div class="dropdown-menu" [class.show]="showMenu">
                            <button class="dropdown-item" (click)="selectGraph('doughnut')">Vista gráfico circular</button>
                            <button class="dropdown-item" (click)="selectGraph('bar')">Vista gráfico barras</button>
                        </div>
                    </div>
                </div>
                <div class="legend mt-4" *ngIf="doughnutChartDatasets && doughnutChartDatasets.length > 0">
                    <div class="d-grid" style="grid-template-columns: 1fr 1fr; column-gap: 20px;">
                        <div *ngFor="let label of doughnutChartLabels; let i = index" class="legend-item">
                            <span class="dot" [style.background-color]="getBackgroundColor(i)"></span>
                            <div class="legend-text">
                                <strong>{{ label }}</strong><br>
                                <span>{{ getData(i) }}</span>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>
